import React, { useContext, useEffect, useState } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import { FullGridContext } from "..";
import EnrollmentProcess from "../Enrollments/Preview/EnrollmentProcess";

export default function CommercialProspects() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "name", asc: true };
  const [selected, setSelected] = useState([]);
  const [enrollmentOpen, setEnrollmentOpen] = useState(false);
  const defaultGridHeader = [
    {
      title: "Name",
      name: "name",
      type: "text",
      filter: false,
    },
    {
      title: "Last Name",
      name: "last_name",
      type: "text",
      filter: false,
    },
    {
      title: "E-mail",
      name: "email",
      type: "text",
      filter: false,
    },
    {
      title: "Type",
      name: "processtypes",
      type: "text",
      filter: true,
    },
    {
      title: "Sub Status",
      name: "processsubstatuses",
      type: "text",
      filter: true,
    },
    {
      title: "Responsible Agent",
      name: "agent",
      type: "text",
      filter: true,
    },
    {
      title: "Partner & Influencer",
      name: "partners_and_influencers",
      type: "text",
      filter: true,
    },
  ];

  const handleEnrollment = () => {
    const newVarOpened = !enrollmentOpen;
    setEnrollmentOpen(newVarOpened);
    if (!newVarOpened) {
      setSelected([]);
      loader();
    }
    handleOpened(null);
  };

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "prospects"
  );
  async function loader() {
    setLoadingData(true);
    const data = await getData("prospects", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });

    if (!data) {
      return;
    }
    const gridDataValues = data.map(
      (
        {
          id,
          name,
          last_name,
          email,
          canceled_at,
          agent,
          processtypes,
          processsubstatuses,
          partners_and_influencers,
        },
        index
      ) => {
        const ret = {
          show: true,
          id,
          fields: [
            name,
            last_name,
            email,
            processtypes?.name,
            processsubstatuses?.name,
            agent?.name,
            partners_and_influencers?.partners_name,
          ],
          selectable: true,
          canceled: canceled_at,
          page: Math.ceil((index + 1) / limit),
        };
        return ret;
      }
    );
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page]);

  const selectionFunctions = [];

  selectionFunctions.push({
    title: "Enrollment",
    alias: "start-prospect-enrollment",
    fun: handleEnrollment,
    icon: "CirclePlay",
    Page: EnrollmentProcess,
    opened: enrollmentOpen,
    setOpened: setEnrollmentOpen,
    selected,
  });

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
      selection={{
        multiple: false,
        selected,
        setSelected,
        functions: selectionFunctions,
      }}
    />
  );
}
